import React from 'react';
import ReactDOM from 'react-dom/client';
import "slick-carousel/slick/slick.css"; 
import './index.css';
import App from './App';
import { ThemeProvider } from './components/theme/ThemeContext';
import { ClickProvider } from './components/banner/ClickContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ClickProvider>
    <ThemeProvider>
    <App />
    </ThemeProvider>
    </ClickProvider>
  </React.StrictMode>
);

